import React from 'react';
import styled from 'styled-components';
import { Icon } from 'bench-internal-theme';

type CardCTAProps = {
  label: string;
  onClick?: () => void;
};

const Container = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #6564ee;
  cursor: pointer;
  font-size: 14px;
  user-select: none;
`;

const Arrow = styled(Icon)`
  margin-left: 5px;
  cursor: pointer;
  transform: rotate(90deg);
`;

const CardCTA = ({ label, onClick }: CardCTAProps) => {
  return (
    <Container onClick={() => (onClick ? onClick() : null)}>
      {label}
      <Arrow icon={'arrowCircleUp'} color={'#5046E5'} size={'20px'} />
    </Container>
  );
};

export default CardCTA;
